module.exports = __webpack_public_path__ + "img/btn-intro.f0451632.jpg";